import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import beautify from 'xml-beautifier';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  propertyName: any;
  version: any;
  // hotelName: any;
  hotelip: any;
  fnSrvSts: any;
  createdatetime:any
}

@Component({
  selector: 'app-nepal-fnmis',
  templateUrl: './nepal-fnmis.component.html',
  styleUrls: ['./nepal-fnmis.component.css'],
    providers: [LoginService,
       {
         provide: DateAdapter,
         useClass: MomentDateAdapter,
         deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
       },
   
       { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
     ]
})
export class NepalFnmisComponent implements OnInit {
pageSize = 50;
  pageSizeOptions: number[]
  storeUserID: any
  apiresult: any;
  statusResult: string;
    ValSearchDownload: any;
  requestPayload: any;
  storeOptionData = "LOG";
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
    searchBarFilter: boolean = false;
    display: Boolean = false;
  public idsProductList: idsProductList[];
    searchValueData: any;
    status: void;
  dataSource: MatTableDataSource<idsProductList>;
    PGF: any = "0";
  PGT: any = "50";
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe) {

  }
  hideSearchFilter(){
    this.ValSearchDownload = '';
    this.searchBarFilter = false
  }
  JSONName: any;
  defaultData: any;
  selected: string;
  selectedItems: any;
  Source: string;
  Userid: any = [];
  public User: string;
  rateCode: string;
  property: string;
  SourceBy: string;
  today = new Date();
  today1: any = new Date();
  selectedDate: any = new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate() - 1));

  isProgressing: Boolean = false;
  Pmscodevalue: any;

  displayedColumns: string[] = ['TOKEN','ExeStatus', 'Operation', 'RegNumber', 'GuestName', 'Arrival', 'Departure','CDATETIME','Request','Response'];

  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any
  ngOnInit() {
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.SourceBy = "LOG";
    this.statusResult = "Not Sent"
    this.Source = "P";
   
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }
callIDSUsersProperties() {
    this.storeUserID = localStorage.getItem("Username");
    console.log('this.storeUserID', this.storeUserID)
    this.apiCallIdsService.getNepalFNMISGetProperties()
      .subscribe(
        data => {
          console.log('New Screen Data', data)

          this.apiresult = data;
          console.log('this.SourceBy =', this.SourceBy)
         /*  if (this.SourceBy == 'LOG') {
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });
          } */

          this.dropdownDeptData = this.apiresult
          if (this.SourceBy == 'LOG') {
        this.selectedDeptItems = this.getDimensionsByFilter("All");
        console.log('this.StoreValuetest',this.selectedDeptItems[0].propertyCode);
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('this.Pmscodevalue =',this.Pmscodevalue)
          }
          this.isProgressing = false;
        });
  }
  getDimensionsByFilter(propertyCode:any){
    console.log('dropdownDeptData =',this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }
  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }
  changeOption(data: any) {
    console.log("changeOption Value--->" + data);
    this.storeOptionData = data
    if (data == 'Re-process') {
      this.statusResult = ""
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    } else {
      this.statusResult = "Not Sent"
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    }
  }
   GetCommonMethodForLog(ValSearchDownload:any) {
        console.log('ValSearchDownload = ',ValSearchDownload)
        this.searchValueData = ValSearchDownload
        this.PGF = "0";
        this.PGT = "50";
        this.GetNepalLOGNew()
    
      }
      GetNepalLOGNew() {
    this.isProgressing = true;
   const frmdate = this.datePipe.transform(this.selectedDate, 'yyyyMMdd')||'';
  const toodate = this.datePipe.transform(this.selectedTOODate, 'yyyyMMdd')||'';

    if(toodate < frmdate ){
    this.isProgressing = false;
    console.log('searchValueData =',this.searchValueData)
    this.toastr.error('From date shuold be less than To date.');
    }else{
      this.requestPayload = {
        "pmscode": this.Pmscodevalue,
        "frmdate": frmdate,
        "toodate": toodate,
        "search": this.ValSearchDownload,
        "status": this.statusResult
      }
  
      console.log('Request =', this.requestPayload)
      this.apiCallIdsService.readNepalFNMISData(this.requestPayload)
        .subscribe(
          data => {
            console.log('Data =', data)
            this.idsProductList = data;
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            console.log('storeOptionData =', this.storeOptionData)
            if (this.storeOptionData == 'LOG') {
              if (data.length > 0) {
                console.log('Log Data = ', data);
                this.errorMsgSubscription = false
                this.displayContent = true
                this.toastr.success('Data loaded Successfully');
                this.isProgressing = false;
              } else {
                this.displayContent = false
                this.errorMsgSubscription = true
                this.errorMessage = "No Data Found"
                this.toastr.error('No Data Found');
                this.isProgressing = false;
              }
            } else {
  
              this.toastr.success(data[0].status)
              this.isProgressing = false;
            }
          });
    }
    
  } 
  pageEvent(e: any) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }


  FOOTFALL() {
    this.User = localStorage.getItem("Username")||'';
    this.apiCallIdsService.getfootfall(this.User, 'BTEA', 'btea upload')
      .subscribe(
        data => {
        });
  }
 showXml(pmscode:any,token: any, xmltype: any) {
 
       this.status = this.LoadXML(pmscode,token, xmltype);
   }
   LoadXML(pmscode: any, token: any, xmltype: any) {

  this.isProgressing = true;

  this.apiCallIdsService.readNepalFNMISJson(pmscode, token, xmltype)
    .subscribe(data => {

      console.log("jsonresult", data);

      if (!data || data.length == 0) {
        this.toastr.error('No data to load');
        this.isProgressing = false;
        return;
      }

      const formatted = JSON.stringify(JSON.parse(data[0].jsonData), null, 4);

      this.JSONName = xmltype === 'Requestjson' ? "Request JSON" : "Response JSON";

      this.defaultData = formatted;

      this.display = true;

      this.isProgressing = false;

    },
    error => {
      this.toastr.error("Failed to load JSON!");
      this.isProgressing = false;
    });
}
   closeModalDialog() {
     this.display = false; //set none css after close dialog
   }
}
